<template>
  <div style="background-color: #edf4fc;">
    <div style="height: 100px;text-align: center;font-size: 30px;line-height: 100px;">
      商科教育专委会介绍
    </div>
    <div style="overflow: hidden;min-height: 5rem;">
      <div style="width: 12%;float: left;padding-left: 1%;">
        <el-menu
          default-active="1"
          @select="handleSelect"
          class="el-menu-vertical-demo"
          background-color="#f8ce63"
          text-color="#000"
          active-text-color="red"
        >
          <el-menu-item index="1">
            <span slot="title">通知</span>
          </el-menu-item>
          <el-menu-item index="2">
            <span slot="title">资讯</span>
          </el-menu-item>
          <el-menu-item index="3">
            <span slot="title">活动</span>
          </el-menu-item>
          <el-menu-item index="4">
            <span slot="title">会员风采</span>
          </el-menu-item>
          <el-menu-item index="5">
            <span slot="title">会员服务</span>
          </el-menu-item>
          <el-menu-item index="6">
            <span slot="title">其他</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div style="width: 80%;float: left;margin-left: 5%;margin-right: 1%;padding-right: 1%;">
        <div style="height: 500px;">
          <div v-for="item in titleData" :key="item.id" class="titleDataDiv">
            <a href="javascript:void(0)" @click="titleContent(item)" class="titleDataA">
              {{ item.title }}
            </a>
          </div>
        </div>
        <el-pagination :current-page="currentPage" :page-size="pageSize" background layout="prev, pager, next" :total="total" @current-change="handleCurrentChange" />
      </div>
    </div>
  </div>
</template>

<script>
// 按需导入 API 接口
import { selectDepartment } from '@/api/departmentAPI'

import '@/assets/quill.snow.css'

export default {
  name: 'Department',
  data() {
    return {
      titleData: [],
      tag: '通知',
      contentData: {},
      currentPage: 1,
      pageSize: 10,
      total: 1
    }
  },
  created() {
    this.selectDepartmentTitle()
  },
  // 导航离开该组件的对应路由时调用
  // 可以访问组件实例 `this`
  beforeRouteLeave(to, from, next) {
    from.meta.top = window.scrollY
    setTimeout(() => {
      next()
    }, 0)
  },
  methods: {
    async selectDepartmentTitle () {
      const { data: res } = await selectDepartment(this.tag, this.currentPage, this.pageSize)
      this.titleData = res.data[2]
      this.total = res.data[0]
    },
    async handleCurrentChange(val) {
      this.currentPage = val
      const { data: res } = await selectDepartment(this.tag, this.currentPage, this.pageSize)
      this.titleData = res.data[2]
      this.total = res.data[0]
    },
    handleSelect(key, keyPath) {
      if (key === '1') {
        this.tag = '通知'
        this.selectDepartmentTitle()
      }
      if (key === '2') {
        this.tag = '资讯'
        this.selectDepartmentTitle()
      }
      if (key === '3') {
        this.tag = '活动'
        this.selectDepartmentTitle()
      }
      if (key === '4') {
        this.tag = '会员风采'
        this.selectDepartmentTitle()
      }
      if (key === '5') {
        this.tag = '会员服务'
        this.selectDepartmentTitle()
      }
      if (key === '6') {
        this.tag = '其他'
        this.selectDepartmentTitle()
      }
    },
    async titleContent (item) {
      this.$router.push({ name: 'Article', params: { id: item.id } })
    }
  }
}
</script>

<style lang="less" scoped>
a {
  color: #000000;
  text-decoration: none;
}
a p div span {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Microsoft YaHei","Hiragino Sans GB","WenQuanYi Micro Hei",Arial,sans-serif;
}
.titleDataDiv {
  height: 45px;
}
.titleDataA {
  display: block;
  width: 96%;
  height: 35px;
  line-height: 35px;
  font-size: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #000;
  padding: 5px;
  margin: 5px;
}
.titleDataA:hover {
  color: red;
  background-color: #ffb700;
  border-radius: 3px;
}
.el-pagination {
  text-align: center;
}
/deep/ .el-menu-item {
  font-size: 22px;
  font-weight: 700;
}
/deep/ .el-menu-item:hover {
  background-color: #ffb700!important;
}
/deep/ .el-menu {
  border: 1px solid #ffb700;
  border-radius: 3px;
}
</style>
